var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFuelLevel = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26.921,
    viewBox: "0 0 30 26.921",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d7282f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 -23.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.5 23.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M78.874,72.15H67.818a.719.719,0,0,0-.718.718v7.308a.719.719,0,0,0,.718.718H78.874a.719.719,0,0,0,.718-.718V72.868A.719.719,0,0,0,78.874,72.15ZM68.537,79.458V73.587h9.619v5.871Z",
    transform: "translate(-62.815 -69.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.775,48.634H17.4V38.828h.924A1.576,1.576,0,0,1,19.9,40.414v1.743a3.4,3.4,0,0,0,6.808,0V32.276a4.151,4.151,0,0,0-1.1-2.829l-4.946-5.636-1.078.948,3.74,4.265a2.606,2.606,0,0,0,.6,5.144,2.657,2.657,0,0,0,1.354-.382v8.371a1.968,1.968,0,0,1-3.935,0v-1.73a3.022,3.022,0,0,0-3-3.036H17.4V25.848a2.686,2.686,0,0,0-2.667-2.7H3.128a2.68,2.68,0,0,0-2.655,2.7V48.634H-.782a.719.719,0,0,0-.718.718.719.719,0,0,0,.718.718H27.782a.718.718,0,1,0-.006-1.437Zm-25.865,0V25.848a1.242,1.242,0,0,1,1.218-1.262H14.734a1.248,1.248,0,0,1,1.23,1.262V48.634ZM25.083,31.557a1.168,1.168,0,1,1-1.168-1.168A1.169,1.169,0,0,1,25.083,31.557Z",
    transform: "translate(1.5 -23.15)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.03 37.412)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M122.544,251.764a.756.756,0,0,0-1.163,0c-.218.363-2.326,3.562-2.326,5.378a2.911,2.911,0,1,0,5.814,0C124.87,255.326,122.834,252.127,122.544,251.764Zm-.581,6.978a1.541,1.541,0,0,1-1.454-1.6,9.637,9.637,0,0,1,1.454-3.561,9.635,9.635,0,0,1,1.454,3.561A1.541,1.541,0,0,1,121.962,258.742Z",
    transform: "translate(-119.055 -251.492)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFuelLevel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fuel-level.495868d3.svg";
export { ForwardRef as ReactComponent };